const trackingVersionMapping = {
  pose: [103, 104, 119],
  biomechanicsAndPose: [112, 114, 117, 115, 116, 118],
  onlyPitchToPlate: [113], // No spin data but has player tracking
  onlyFullPitch: [111, 109, 100, 101, 106], // No player tracking
  
  mlbSystemVersion: [112, 103],
  mlbSystemOwner: [1],

  clubOwnedSystemVersion: [114, 117, 119],
  clubOwnedSystemOwner: [2],

  hybridOwnedSystemVersion: [115, 116, 118],
  hybridOwnedSystemOwner: [3],
  
  trackmanOwnedSystemVersion: [111],
  trackmanOwnedSystemOwner: [2]
};

export default trackingVersionMapping;
